import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ContentChild,
  ElementRef,
  EventEmitter,
  HostBinding,
  inject,
  Input,
  input,
  OnDestroy,
  OnInit,
  Output,
  signal,
  ViewEncapsulation
} from '@angular/core';

import { MatButtonModule } from '@angular/material/button';

import { AsyncFnService, TAsyncFnPendingInd, TAsyncFnWrapper } from '@partners/utils';
import { Subscription } from 'rxjs';
import { IButtonAction } from '../../model/ui.interface';
import { TElementFlow, TResponsiveSize } from '../../model/ui.types';
import { ButtonContentSlotDirective } from '../button-content';

@Component({
  template: ``,
  standalone: true,
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'button'
  },
  imports: [MatButtonModule]
})
export class BaseButtonComponent implements OnInit, OnDestroy {
  @Input()
  @HostBinding('attr.form')
  formName: string;

  @Input()
  type: 'submit' | 'button' = 'button';

  @Input()
  context: any;

  @Input()
  value: string | number;

  /** comply with preset responsive ui sizes */
  @Input()
  size: TResponsiveSize;

  clickFnTrailTime = input<number>(0);

  iconName = input<string>();

  iconSize = input<TResponsiveSize>();

  flow = input<TElementFlow | 'grid'>('grid');

  hasRootTemplate = input<boolean>(false);

  pending = signal<boolean>(false);

  clickFn = input<TAsyncFnWrapper>(undefined);
  pendingInd = input<TAsyncFnPendingInd>(this.pending);

  @Input()
  @HostBinding('class.disabled')
  disabled: boolean = false;

  @Output()
  click: EventEmitter<IButtonAction>;

  @HostBinding('class.inline')
  get inlineClass() {
    return this.flow() === 'inline';
  }
  @HostBinding('class.inline-block')
  get inlineBlockClass() {
    return this.flow() === 'inline-block';
  }
  @HostBinding('class.block')
  get blockClass() {
    return this.flow() === 'block';
  }

  @HostBinding('class')
  get sizeClass() {
    return this.size;
  }

  /** the content template passed from host */
  @ContentChild(ButtonContentSlotDirective, { static: true })
  buttonContent: ButtonContentSlotDirective;

  get buttonEl(): HTMLButtonElement {
    return this.elementRef.nativeElement.querySelector('button');
  }

  protected changeDetector = inject(ChangeDetectorRef);
  protected elementRef = inject(ElementRef);
  protected _asyncClickService = inject(AsyncFnService);

  private _subscription: Subscription;

  constructor() {
    this.click = new EventEmitter<IButtonAction>();
    this._subscription = new Subscription();
  }

  /**
   * house keeping
   */
  ngOnDestroy(): void {
    this._subscription.unsubscribe();
    this.click.complete();
  }

  ngOnInit(): void {
    this.changeDetector.detectChanges();
  }
}
